import { useEffect, useState } from 'react';
import { DjangoListResponse, User, ItemList } from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import { SelectOption } from 'v2/form/CustomSelectors/Multiselect/MultiFilterDropdown';
import { namedUser } from 'v2/form/CustomSelectors/Multiselect/MultiSelectUser/MultiSelectUser';

const initalState = { is_all: false, list: [] };

const loadOptions = async (
  inputValue: string,
  callback: (options: SelectOption<namedUser>[]) => void
) => {
  try {
    const data = await restFactory.get<DjangoListResponse<User>>(
      '/dj/api/v1/strapi_user/',
      { search: inputValue }
    );
    const options: SelectOption<namedUser>[] = data.results.map((user) => {
      const userName = `${user.first_name || ''} ${user.last_name || ''}`;
      return {
        label: userName,
        value: { ...user, name: userName },
      };
    });
    callback(options);
  } catch (error) {
    callback([]);
  }
};

export const useMultiSelectUserOptions = () => {
  const [defaultOptions, setDefaultOptions] = useState<
    SelectOption<namedUser>[]
  >([]);
  const [currentState, setCurrentState] = useState<ItemList>(initalState);

  useEffect(() => {
    loadOptions('', (options) => setDefaultOptions(options));
  }, []);

  return {
    defaultOptions,
    loadOptions,
    currentState,
    setCurrentState,
  };
};
